import axios from '../../../api/axios';
import { AuthResponse, LoginRequest } from '../types';

export async function loginCustomer(payload: LoginRequest): Promise<AuthResponse> {
  const response = await axios.post('/auth/customer/login', payload);
  return response.data;
}

export async function loginAdmin(payload: LoginRequest): Promise<AuthResponse> {
  const response = await axios.post('/auth/admin/login', payload);
  return response.data;
}

export async function loginDeliveryBoy(payload: LoginRequest): Promise<AuthResponse> {
  const response = await axios.post('/auth/delivery-boy/login', payload);
  return response.data;
}

export async function registerCustomer(payload: {
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  password: string;
}) {
  return axios.post('/auth/register', {
    ...payload,
    roles: ['customer'],
  });
}